export default {
  translation: {
    common: {
      emailOrUsername: "Email ou nom d'utilisateur",
      invalidEmailOrUsername: "Email ou nom d'utilisateur invalide",
      invalidPassword: 'Mot de passe invalide',
      logInToPlanka: 'Se connecter à Planka',
      noInternetConnection: 'Aucune connection internet',
      pageNotFound_title: 'Page non trouvée',
      password: 'Mot de passe',
      projectManagement: 'Gestion de projet',
      serverConnectionFailed: 'Connection au serveur échouée',
      unknownError: 'Erreur inconnue, réessayez plus tard',
      useSingleSignOn: "Utiliser l'authentification unique",
    },

    action: {
      logIn: 'Se connecter',
      logInWithSSO: "Se connecter avec l'authentification unique",
    },
  },
};
